var _path, _circle, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerminating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2351 2.28766C12.5424 2.38909 12.75 2.67623 12.75 2.99987V9.44987H16C16.2833 9.44987 16.5424 9.60948 16.6698 9.86247C16.7973 10.1155 16.7713 10.4187 16.6027 10.6463L8.60267 21.4463C8.41003 21.7064 8.07229 21.8135 7.76495 21.7121C7.45761 21.6107 7.25 21.3235 7.25 20.9999V14.5499H4C3.71673 14.5499 3.45762 14.3903 3.33018 14.1373C3.20275 13.8843 3.22872 13.5811 3.39734 13.3535L11.3973 2.55345C11.59 2.29339 11.9277 2.18623 12.2351 2.28766ZM5.48891 13.0499H8C8.41422 13.0499 8.75 13.3857 8.75 13.7999V18.7274L14.5111 10.9499H12C11.5858 10.9499 11.25 10.6141 11.25 10.1999V5.2724L5.48891 13.0499Z",
    fill: "#1D79F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 17,
    r: 5,
    fill: "#E34850"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6519 14.3487C17.9448 14.6416 17.9448 15.1165 17.6519 15.4094L13.4092 19.652C13.1163 19.9449 12.6415 19.9449 12.3486 19.652C12.0557 19.3591 12.0557 18.8842 12.3486 18.5913L16.5912 14.3487C16.8841 14.0558 17.359 14.0558 17.6519 14.3487Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6519 19.652C17.359 19.9449 16.8841 19.9449 16.5912 19.652L12.3486 15.4094C12.0557 15.1165 12.0557 14.6416 12.3486 14.3487C12.6415 14.0558 13.1163 14.0558 13.4092 14.3487L17.6519 18.5913C17.9448 18.8842 17.9448 19.3591 17.6519 19.652Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminating);
export default __webpack_public_path__ + "static/media/Terminating.ab6bf65c9f2552d7a8c8ded14f58afbb.svg";
export { ForwardRef as ReactComponent };